// Períodos aceitos pelo endpoint POST /:companyId/reportCarts/analiticoCarts.
//
// O backend (cart.service.js -> getAllCart) filtra por `createdAt`:
//   total       -> sem filtro de data
//   ativos      -> createdAt > hoje-1d
//   paralizados -> createdAt entre hoje-2d e hoje-1d
//   inativos    -> createdAt <= hoje-2d
//
// Qualquer valor fora dessa lista cai no default do backend (sem filtro), então
// aqui normalizamos para "total" e evitamos telas com filtro implícito — foi
// justamente um `time: "inativos"` fixo que fazia a aba de Carrinhos (Config →
// Produto) esconder carrinhos recentes que apareciam na tela de Carrinho.
export const CART_PERIODS = [
  { value: "total", label: "Todos" },
  { value: "ativos", label: "Ativos (24h)" },
  { value: "paralizados", label: "Paralisados (24h-48h)" },
  { value: "inativos", label: "Inativos (+48h)" },
];

export const DEFAULT_CART_PERIOD = "total";

export function normalizeCartPeriod(time) {
  return CART_PERIODS.some((p) => p.value === time) ? time : DEFAULT_CART_PERIOD;
}

// Body da consulta analítica de carrinhos.
export function buildAnaliticoCartsBody({ time, stories } = {}) {
  return {
    time: normalizeCartPeriod(time),
    stories: Array.isArray(stories) ? stories : [],
  };
}
